import React from 'react';

import { useFilters } from '../hooks/useFilters';
import { ALL_FILTERS } from '../utils/variables';

import ArticleCard from './ArticleCard';
import Filters from './Filters';

export default function Articles({ section }) {
  const { references = [], articles } = section;
  const articlesCategories = [
    {
      id: ALL_FILTERS.id,
      title: ALL_FILTERS.title
    },
    ...references
  ];
  const { selectedElement, setSelectedElement, isAllFilter } =
    useFilters(articlesCategories);

  const filteredArticles = articles?.filter(
    (article) =>
      article.node.categories.some(
        (category) => category.id === selectedElement?.id
      ) || isAllFilter()
  );

  return (
    <div className="articles">
      {articlesCategories.length > 1 && (
        <Filters
          filters={articlesCategories}
          handleClick={setSelectedElement}
          selectedElement={selectedElement}
        />
      )}
      {filteredArticles && (
        <div className="articles__grid">
          {filteredArticles.map((article) => (
            <ArticleCard article={article.node} key={article.node.id} />
          ))}
        </div>
      )}
    </div>
  );
}
